module.exports = __webpack_public_path__ + "eu.svg?d8c5128679452fbb1742dc0b0fafcfe6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/eu.svg
// module id = 1455
// module chunks = 0